module.exports = (__parcel__import__("c3k17")).then(() => parcelRequire('jppWD'));